export function enrichTopupOffer(offer, brands = {}) {
  const brandKey = offer.brand?.toLowerCase?.();
  const brandData = brandKey ? brands[brandKey] : null;

  // derive requiredFields for topups
  const baseReq = (Array.isArray(offer.requiredFields) && offer.requiredFields.length)
    ? [...offer.requiredFields]
    : ['recipient.msisdn', 'recipient.country'];

  if (offer.requiresEmail === true || offer.delivery === 'EMAIL') {
    if (!baseReq.includes('recipient.email')) baseReq.push('recipient.email');
  }

  return {
    ...offer,
    productType: 'TOPUP',
    requiredFields: baseReq, // ✅ now present for SelectedProductSummary
    brandName: brandData?.brandName || offer.brand || 'Unknown Topup Brand',
    image: brandData?.image || null,
    priceDisplay:
      offer.price && offer.priceCurrencyDivisor
        ? (offer.price / offer.priceCurrencyDivisor).toFixed(2)
        : 'N/A',
    sendDisplay:
      offer.send && offer.sendCurrencyDivisor
        ? (offer.send / offer.sendCurrencyDivisor).toFixed(2)
        : null,
    country: offer.country || offer.fullDetail?.country || '',
    regions: offer.regions || offer.fullDetail?.regions || [],
    subTypes: offer.subTypes || offer.fullDetail?.subTypes || [],
  };
}
